import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    menuisLoading : false,
    menu: [],
    totalCurrency: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    menuisCLoading:false,
    menuCstatus:"",
    menuCMessage:"",
    menudetails:{},
    menuismloading:false,
    menumstatus:"",
    menummessage:"",
    menues: {},
    menudstatus:"",
    menudmessage:"",
    error:"",
    
};


const menuSlice = createSlice({
    name: "menuList",
    initialState,
    reducers:{
        getMenuPending: (state) => {
            state.menuisLoading = true;
        },
        getMenuSuccess: (state, { payload }) => {
            state.menuisLoading = false;
            state.menu = payload;
            // state.menudetails = payload;
           // state.user="slice userData";
            state.error = '';
        },
        getMenuFail: (state, { payload }) => {
            state.menuisLoading = false;
            state.error = payload;
        },
        // createCityPending:(state,action) => {
        //     state.cityiscLoading=true;
        // },
        // createCitySuccess:(state,{payload}) => {
        //     state.cityiscLoading=false;
        //     state.cityCstatus="success";
        //     state.cityCMessage=payload;
        // },
        // createCityFail:(state,{payload}) => {
        //     state.cityiscLoading=false;
        //     state.cityCstatus="fail";
        //     //console.log('slice '+payload);
        //     state.cityCMessage=payload;
        // },
        // getSCityPending: (state) => {
        //     state.cityisLoading = true;
        // },
        // getSCitySuccess: (state, { payload }) => {
        //     state.cityisLoading = false;
        //     state.cities=payload;
        //    // state.user="slice userData";
        //     state.error = '';
        // },
        // getSCityFail: (state, { payload }) => {
        //     state.cityisLoading = false;
        //     state.error = payload;
        // },
        // modifyCityPending:(state,action) => {
        //     state.cityismloading=true;
        //     state.citymstatus="";
        // },
        // modifyCitySuccess:(state,{payload}) => {
        //     state.cityismloading=false;
        //     state.citymstatus="success";
           
        //     state.citymmessage="City Successfully Updated";
        // },
        // modifyCityFail:(state,{payload}) => {
        //     state.cityismloading=false;
        //     state.citymstatus="fail";
        //    // console.log('slice '+payload);
        //     state.citymmessage=payload;
        // },
        // deleteCityPending:(state,action) => {
        //     state.cityisLoading=true;
        //     state.citydstatus="";
        // },
        // deleteCitySuccess:(state,{payload}) => {
        //     state.cityisLoading=false;
        //     state.citydstatus="success";
        //     state.citydmessage="City Successfully Deleted";
        // },
        // deleteCityFail:(state,{payload}) => {
        //     state.cityisLoading=false;
        //     state.citydstatus="fail";
        //    // console.log('slice '+payload);
        //     state.citydmessage=payload;
        // },
        reset: () => initialState
    },
});

const { reducer, actions } = menuSlice;

export const { getMenuPending, getMenuSuccess, getMenuFail } = actions;

export default reducer;
